import { apiClient } from "../../../../../api/client";
import { ApiResponse } from "../../../../../types";
import {
  BaixaItem,
  BaixaListParams,
  BaixaDocStartParams,
  BaixaSubmitDbParams,
  EntregoBaixaListParams,
  EntregoBaixaItem,
  EntregoOpsItem,
} from "../types";

export const baixaService = {
  async getBaixaList(
    params: BaixaListParams
  ): Promise<ApiResponse<BaixaItem[]>> {
    return apiClient.post("/gestorBaixaList", params);
  },

  async getEntregoBaixaList(
    params: EntregoBaixaListParams
  ): Promise<ApiResponse<EntregoBaixaItem[] | EntregoOpsItem[]>> {
    return apiClient.post("/gestorBaixaListEntrego", params);
  },

  async startBaixaDoc(
    params: BaixaDocStartParams
  ): Promise<ApiResponse<void>> {
    return apiClient.post("/gestorBaixaDocStart", params);
  },

  async submitBaixaDb(
    params: BaixaSubmitDbParams
  ): Promise<ApiResponse<void>> {
    return apiClient.post("/gestorSubmitBaixaDb", params);
  },
};
